import React from 'react';
import {
  HashRouter, Route, Switch, Redirect,
} from 'react-router-dom';
import { LocaleProvider } from 'antd';
import esEs from 'antd/lib/locale-provider/es_ES';
import MainPage from './modules/app/pages/main.page';
import { Box } from './modules/shared/components/basic';
import EjemploMostrar from './modules/ejemplo/pages/ejemplo.mostrar.page';
import AgendaMostrar from './modules/agenda/pages/agenda.mostrar.page';
import MessageReceiver from './modules/app/components/messageReceiver';


export const authenticatedRouter = ({ history }) => (
  <LocaleProvider locale={esEs}>
    <HashRouter history={history}>
      <MessageReceiver />
      <Box>
        <Switch>
          <Route exact path="/agenda/:token" component={AgendaMostrar} />
          <Redirect to="/agenda/:token" />
        </Switch>
      </Box>
    </HashRouter>
  </LocaleProvider>
);
